export const Periods = Object.freeze({
  UPCOMING: 'upcoming',
  PAST: 'past',
  FIXED: 'fixed',
  THIS_WEEK: 'this_week',
  LAST_WEEK: 'last_week',
  THIS_MONTH: 'this_month',
  THIS_YEAR: 'this_year',
  TODAY: 'today',
  ALL_TIME: 'all_time'
})

export const Statuses = {
  ALL: 'all',
  ACTIVE: 'active',
  CANCELED: 'canceled',
  NO_SHOW: 'no_show',
  RESCHEDULED: 'rescheduled',
}

export const STATUS_MAP = {
  [Statuses.ACTIVE]: 'DEFAULT',
  [Statuses.CANCELED]: 'CANCELED',
  [Statuses.NO_SHOW]: 'NO_SHOW',
  [Statuses.RESCHEDULED]: 'RESCHEDULED'
}

export const SchedulingMethods = {
  ALL: 'all',
  CALENDLY: 'calendly',
  GOOGLE: 'google',
  OUTLOOK: 'outlook'
}

export const AllSchedulingMethods = [
  SchedulingMethods.CALENDLY,
  SchedulingMethods.GOOGLE,
  SchedulingMethods.OUTLOOK
]

/**
 * Normalize persisted/URL scheduling_methods for the filter UI.
 * - Empty or invalid → All (show "All" selected).
 * - Single method → return as-is (one radio selected).
 * - Two or more methods → All (avoids no-radio-selected state for legacy or URL combos
 *   like [calendly, google], [google, outlook], [calendly, outlook]).
 */
export const normalizePersistedSchedulingMethods = (persisted) => {
  if (!Array.isArray(persisted) || persisted.length === 0) return AllSchedulingMethods
  if (persisted.length === 1) return persisted
  return AllSchedulingMethods
}

/**
 * Normalize URL/query params to AllSchedulingMethods when value is the "all" option or
 * legacy "all" (calendly+google only) for consistent filter UI.
 */
export const buildSchedulingMethodProps = ({ scheduling_methods: schedulingMethods }) => {
  if (Array.isArray(schedulingMethods)) {
    if (schedulingMethods.length === 1 && schedulingMethods[0] === SchedulingMethods.ALL) {
      return AllSchedulingMethods
    }

    const validMethods = schedulingMethods.filter((value) => Object.values(SchedulingMethods).includes(value))

    if (validMethods.length) {
      return normalizePersistedSchedulingMethods(validMethods)
    }
  }

  return AllSchedulingMethods
}
